<template>
	<!-- 合同管理 -->
	<div class="main">
		<div class="top">
			<img @click="searchClick()" src="@/assets/images/search.svg"
				style="width:1.2rem;margin:10px 8px;right: .5rem;position: absolute;display: inline-block;" />
			<van-dropdown-menu style="max-width: 90%; float:left;margin-left: .5rem;">
				<van-dropdown-item v-model="qyvalue" :options="qylist" @change="qyItemChange()" />
			</van-dropdown-menu>
		</div>
		<div class="content">
			<div class="navlist" style="z-index: 8">
				<div class="navitem" v-for="(item,index) in nav" @click="navClick(index)">
					<div :class="{ textcolor333:index===navActive,textcolor999:index!=navActive }"
						class="navitemtitle text14">{{item.title}}
					</div>
					<div class="navitembottom" v-show="index===navActive"></div>
				</div>
				<div class="navfilter" @click="showFilterTop=!showFilterTop">
					<img src="@/assets/images/u38.png" style="width:1rem;margin: .5rem 0;">
					<span class="text14 textcolor333" style="line-height: 2rem;margin-left: .1rem;">筛选</span>
				</div>
			</div>
			<div class="horizontal_line" style="z-index: 8;"></div>
			<div style="position: relative;">
				<div class="filterpop" :class="{pophidden:!showFilterTop,popshow:showFilterTop}">
					<div style="padding: 0 .5rem;">
						<!-- <div class="text14 textcolor333" style="margin-top: .5rem;">合同状态</div>
						<div class="horizontal_flex flex_space-around" style="margin-top: .2rem;">
							<span class="text12 textcolor333" v-for="(item,index) in contractStatus" :style="{'background-color': '#f2f2f2'}"
								:key="index">{{item}}</span>
						</div> -->
						<div class="text14 textcolor333" style="margin-top: 1rem;">发起时间</div>
						<div class="horizontal_flex flex_space-around" style="margin-top: .2rem;">
							<span class="text12 textcolor333" v-for="(item,index) in contractTime"
								@click="selectTimeClick(index)"
								:style="{'background-color': (timeIndex==index)?'#cccccc':'#f2f2f2'}"
								:key="index">{{item}}</span>
						</div>
						<div class="horizontal_flex flex_space-around" style="margin-top: .8rem;">
							<div class="time text12 textcolor333" @click="dateShow = true">
								{{beginTimeShow===''?'开始日期':beginTimeShow}}
							</div>
							<div class="time text12 textcolor333" @click="dateShow = true">
								{{endTimeShow===''?'结束日期':endTimeShow}}
							</div>
						</div>
					</div>
					<div class="horizontal_line" style="margin-top: 1rem;"></div>
					<div class="horizontal_flex flex_wrap" style="height: 2rem;">
						<div class="text14 textcolor333 all_height_line20 backgroundC_white bwhite_ative"
							style="width: 49.9%;text-align: center;" @click="resetTimeClick()">重置
						</div>
						<div class="vertical_line"></div>
						<div class="text14 textcolorwhite all_height_line20 backgroundC_main bmain_active"
							style="width: 49.9%;text-align: center;" @click="sumbitTimeClick()">确认</div>
					</div>
					<div class="horizontal_line"></div>
				</div>
				<div ref="contractList" class="all_list_content_nopadding"
					style="top:1px; min-height: 80vh;height: auto;">
					<van-pull-refresh v-model="refreshing" @refresh="onRefresh">
						<van-list v-model="listloading" :finished="listfinished" finished-text="没有更多了" @load="onLoad"
							v-show="list.length>0">
							<div class="list" v-for="(item,index) in list" :key="index">
								<div class="listitem" @click="itemClick(item)">
									<div class="listitemtitle text14 textcolor333 font_weight_700">
										{{Tool.isNoEmpty(item.contractName)?item.contractName:''}}
									</div>
									<div class="listitemcontent text12 textcolor999" style="margin-top: .5rem;">
										{{'合同编号： '+(Tool.isNoEmpty(item.contractCode)?item.contractCode:'-')}}
									</div>
									<div class="listitemcontent text12 textcolor999">
										<span class="display_inline_block text12 textcolor999"
											style="width: 75%;">{{'接收时间： '+(Tool.isNoEmpty(item.createdTime)?Tool.dateFormate(item.createdTime):'-')}}</span>
										<span class="display_inline_block text14 all_height_line10"
											:class="{textcolormain:item.contractStatusText === '待签名'||item.contractStatusText === '待盖章',textcolorAuth:item.contractStatusText === '已完成'}"
											style="width: 20%;">{{item.contractStatusText}}</span>
									</div>
									<!-- <div class="listitemstatus text12 all_text_center" :class="{sign_status_ing:(item.contractStatus==0||item.contractStatus==1),
									sign_status_ed:item.contractStatus==2,sign_status_can:item.contractStatus==3}">
										{{item.contractStatusText}}
									</div> -->
								</div>
								<div class="horizontal_line"></div>
							</div>
						</van-list>
						<van-empty style="margin-top: 20vh;margin-bottom: 20vh;" description="没有数据" v-show="list.length==0" />
					</van-pull-refresh>
				</div>
			</div>
		</div>
		<van-calendar v-model:show="dateShow" type="range" :min-date="minDate" :max-date="maxDate" @confirm="onConfirm"
			color="#0277FC" />
	</div>
</template>

<script>
	import Vue from 'vue'
	import {
		DropdownMenu,
		DropdownItem,
		Calendar,
		Empty,
		PullRefresh,
		List,
	} from "vant";
	//Vue.use(DropdownMenu).use(DropdownItem).use(Calendar).use(Empty).use(PullRefresh).use(List);
	export default {
		name: 'contractmanagement',
		components: {
			[DropdownMenu.name]: DropdownMenu,
			[DropdownItem.name]: DropdownItem,
			[Calendar.name]: Calendar,
			[Empty.name]: Empty,
			[PullRefresh.name]: PullRefresh,
			[List.name]: List,
		},
		data() {
			return {
				//消息列表合同类型
				contractType: '',
				//是否刷新
				refreshing: false,
				//选中active
				navActive: 0, //navindex
				nav: [{
						title: '待签约',
						id: 1,
					},
					{
						title: '已完成',
						id: 2,
					},
					{
						title: '已取消',
						id: 3,
					},
				],
				//企业选中id
				qyvalue: null,
				//企业列表
				qylist: [],
				//筛选下拉界面开关
				showFilterTop: false,
				contractStatus: [
					'全部',
					'待签署',
					'已完成',
					'已取消',
				],
				contractTime: [
					'全部',
					'今天',
					'近一周',
					'近一月',
				],
				timeIndex: 0,
				dateRange: [],
				dateShow: false,
				minDate: new Date(2018, 0, 1),
				maxDate: new Date(),
				listloading: false,
				listfinished: false,
				//开始时间
				beginTime: '',
				//结束时间
				endTime: '',
				//开始时间
				beginTimeShow: '',
				//结束时间
				endTimeShow: '',
				//每页数量
				pageSize: 10,
				//第几页
				pageNum: 0,
				//合同列表
				list: [],
				//active: 0,
				//color: '#0277FC',
				//滑动高度
				scrollTop: 0,
				//操作item
				selectItem: null,
			}
		},
		activated() {
			console.log('cm-activated')
			if (this.scrollTop != 0) {
				this.$refs.contractList.scrollTop = this.scrollTop
			}
			if (this.$store.state.contractStatus && this.selectItem) {
				this.getContractDetails()
			}
		},
		deactivated() {
			//console.log('cm-deactivated')
		},
		//拦截设置keepalive是否缓存
		beforeRouteLeave(to, from, next) {
			//console.log("el-beforeRouteLeave", to, from);
			if (to.meta.index > from.meta.index) {
				if (from.meta.keepAlive) {
					this.$store.commit('addIndexKeepAlive', from.name);
				}
			} else {
				if (from.meta.keepAlive) {
					this.$store.commit('removeIndexKeepAlive', from.name);
				}
			}
			//console.log(this.$store.state.indexKeepAlive)
			next();
		},
		mounted() {
			//console.log('------------',new Date().toISOString())
			let status = this.$route.query.status
			if (status) {
				this.navActive = Number(status)
			}
			/*else{
				console.log('contract_mounted_newContractStatus', this.$store.state.newContractStatus)
				this.contractType = this.$store.state.newContractStatus
				switch (this.contractType) {
					case '待签约':
						this.navActive = 0
						break;
					case '完成签约':
						this.navActive = 1
						break;
					case '取消签约':
						this.navActive = 2
						break;
				}
			}*/
			this.$refs.contractList.addEventListener('scroll', this.contractListScroll);
			this.getEnterpriseList()
			this.onRefresh()
			this.$store.commit('changeContractStatus', false)
		},
		destroyed() {},
		methods: {
			//列表滑动
			contractListScroll(event) {
				this.changeShowFilterTop()
				//记录位置
				//console.log(this.$refs.contractList.scrollTop)
				this.scrollTop = this.$refs.contractList.scrollTop
			},
			//条件显示
			changeShowFilterTop() {
				if (this.showFilterTop) {
					this.showFilterTop = false
				}
			},
			// contractListClick() {
			// 	this.showFilterTop = false
			// },
			//搜索页面
			searchClick() {
				this.$router.push({
					path: '/contractsearch'
				})
			},
			//查看合同详情
			itemClick(item) {
				this.selectItem = item
				this.changeShowFilterTop()
				this.$router.push({
					path: '/contractdetails',
					query: {
						contractId: item.contractId,
						contractStatus: this.navActive
						//corpId: item.corpId
					}
				})
			},
			//条件变化，重新加载
			onReLoad() {
				this.showFilterTop = false
				this.refreshing = true
				this.onRefresh()
			},
			// 下拉刷新
			onRefresh() {
				//this.getEnterpriseList()
				this.changeShowFilterTop()
				this.$store.dispatch(this.$LoadShow, true)
				this.listfinished = false;
				// 将 loading 设置为 true，表示处于加载状态
				this.listloading = true;
				this.pageNum = 0
				this.onLoad();
			},
			// 上拉加载
			onLoad() {
				// 清空列表数据
				if (this.refreshing) {
					this.list = [];
					this.refreshing = false;
				}
				this.pageNum++
				this.getContractList(this.navActive)
			},
			//获取合同列表
			getContractList(status) {
				let url = ''
				switch (this.navActive) {
					case 0:
						url = '/contract/api/queryPagedActingContracts'
						break;
					case 1:
						url = '/contract/api/queryPagedCompletedContracts'
						break;
					case 2:
						url = '/contract/api/queryPagedCancelledContracts'
						break;
				}
				this.$post(url, JSON.stringify({
					corpId: this.qyvalue,
					beginDate: this.beginTime,
					endDate: this.endTime,
					pageParams: {
						desc: true,
						orderBy: "created_time",
						current: this.pageNum,
						size: this.pageSize,
					}
				})).then((res) => {
					this.$store.dispatch(this.$LoadShow, false)
					this.listloading = false;
					if (res.success && res.data) {
						if (this.navActive === status) {
							if (this.navActive === 0) {
								res.data.records.forEach(item => {
									item.corps.forEach(corp => {
										if (corp.showSignAction || corp.showSealAction) {
											if (!item.contractStatusText) {
												item.contractStatusText = corp.actStatusText
											} else if (item.contractStatusText === '待盖章') {
												if (corp.actStatusText === '待签名') {
													item.contractStatusText = corp.actStatusText
												}
											}
										}
									})
									if (!item.contractStatusText) {
										item.contractStatusText = '已完成'
									}
								})
							}
							this.list = this.list.concat(res.data.records);
							// 加载状态结束
							this.listloading = false;
							//数据全部加载完成
							if (this.list.length >= res.data.total) {
								this.listfinished = true;
							}
						}
					} else {
						this.$Toast(res.message || '网络异常！');
					}
				})
			},
			//获取合同详情
			getContractDetails() {
				this.$store.dispatch(this.$LoadShow, true)
				this.$post("/contract/api/getContractDetail?contractId=" + this.selectItem.contractId).then((res) => {
					this.$store.commit('changeContractStatus', false)
					this.$store.dispatch(this.$LoadShow, false)
					if (res.success && res.data) {
						if (res.data.contractStatus === 1 || res.data.contractStatus === 2) {
							this.$refs.contractList.scrollTop = 0
							this.navActive = res.data.contractStatus
						}
						this.onReLoad()
					}
				});
			},
			//选择条件类型
			selectTimeClick(index) {
				if (this.timeIndex != index) {
					let currData = new Date()
					switch (index) {
						case 0:
							this.beginTime = ''
							this.beginTimeShow = ''
							this.endTime = ''
							this.endTimeShow = ''
							break;
						case 1:
							this.endTime = this.Tool.getDataISOString(currData.toISOString())
							this.endTimeShow = this.Tool.formate(currData, 'yyyy-MM-dd')
							currData.setDate(currData.getDate() - 1)
							this.beginTime = this.Tool.getDataISOString(currData.toISOString())
							this.beginTimeShow = this.Tool.formate(currData, 'yyyy-MM-dd')
							break;
						case 2:
							this.endTime = this.Tool.getDataISOString(currData.toISOString())
							this.endTimeShow = this.Tool.formate(currData, 'yyyy-MM-dd')
							currData.setDate(currData.getDate() - 7)
							this.beginTime = this.Tool.getDataISOString(currData.toISOString())
							this.beginTimeShow = this.Tool.formate(currData, 'yyyy-MM-dd')
							break;
						case 3:
							this.endTime = this.Tool.getDataISOString(currData.toISOString())
							this.endTimeShow = this.Tool.formate(currData, 'yyyy-MM-dd')
							currData.setDate(currData.getDate() - 30)
							this.beginTime = this.Tool.getDataISOString(currData.toISOString())
							this.beginTimeShow = this.Tool.formate(currData, 'yyyy-MM-dd')
							break;
					}
					this.timeIndex = index
				}
			},
			//重置
			resetTimeClick() {
				this.selectTimeClick(0)
				this.showFilterTop = false
				this.onReLoad()
			},
			//确定
			sumbitTimeClick() {
				this.showFilterTop = false
				this.onReLoad()
			},
			//选择合同类型
			navClick(index) {
				if (this.navActive != index) {
					this.navActive = index
					this.onReLoad()
				}
			},
			//选择时间范围
			onConfirm(values) {
				var start = values[0]
				var end = values[1]
				this.dateShow = false
				this.beginTime = this.Tool.getDataISOString(start.toISOString())
				this.endTime = this.Tool.getDataISOString(end.toISOString())
				this.beginTimeShow = start.getFullYear() + "-" + (start.getMonth() + 1) + "-" + start.getDate()
				this.endTimeShow = end.getFullYear() + "-" + (end.getMonth() + 1) + "-" + end.getDate()
			},
			//企业下拉列表改变
			qyItemChange() {
				this.selectTimeClick(0)
				this.navActive = 0
				//console.log('改变了' + this.qyvalue)
				this.onReLoad()
			},
			//获取企业列表数据
			getEnterpriseList() {
				// 清空列表数据
				this.$get("/contract/api/getMyCorps").then((res) => {
					this.qylist = []
					this.qylist.push({
						value: null,
						text: '全部企业'
					})
					if (res.success && res.data) {
						for (let item of res.data) {
							this.qylist.push({
								value: item.corpId,
								text: item.corpName
							})
						}
						//console.log(this.qylist)
					} else {
						//console.log(res)
						//this.$Toast('获取企业列表失败！')
					}
				});
			}
		},
	}
</script>

<style scoped lang="scss">
	@import "../../styles/global.css";

	.main {
		position: relative;
		padding-top: 4rem;
		height: 100%;

		.top {
			position: absolute;
			top: 1.8rem;
			z-index: 10;
			width: 100%;
		}

		.content {
			background-color: "#ededed";
			padding: 0;
		}

		.navlist {
			display: flex;
			display: -webkit-flex;
			flex-direction: row;
			width: 100%;
			background-color: white;
			position: relative;

			.navitem {
				padding: 0 .5rem;

				.navitemtitle {
					height: 1.8rem;
					padding: 0 .05rem;
					line-height: 1.8rem;
					padding-top: .2rem;
				}

				.navitembottom {
					width: 1rem;
					height: .2rem;
					margin: 0 auto;
					background-color: #0277FC;
				}
			}

			.navfilter {
				//float: right;
				position: absolute;
				display: -webkit-flex;
				display: flex;
				right: .5rem;
				top: 0;
				height: 2rem;
			}
		}

		.filterpop {
			position: absolute;
			z-index: 6;
			width: 100%;
			// height: 11.4rem;
			transition: top .3s linear 0s;
			background-color: white;

			span {
				width: 3rem;
				line-height: 1.4rem;
				text-align: center;
				border-radius: .8rem;
			}

			.time {
				width: 6rem;
				line-height: 1.4rem;
				text-align: center;
				border-radius: 1rem;
				border: 1px solid #cccccc;

			}

		}

		.pophidden {
			top: -11.45rem;
		}

		.popshow {
			top: 0.005rem;
		}

		.list {
			// padding: .1rem 0;
			// padding-top: .5rem;
			// margin-top: .2rem;
			height: auto;

			.listitem {
				width: 100%;
				padding: .5rem;
				background-color: white;
				position: relative;

				.listitemtitle {
					width: 85%;
					font-weight: bold;
					line-height: 1.2rem;
				}

				.listitemcontent {
					margin-top: .4rem;
					line-height: .6rem;
				}

				.listitemstatus {
					position: absolute;
					top: .3rem;
					right: .5rem;
					width: 2.8rem;
					height: 1rem;
					line-height: 1rem;
					color: white;
					border-radius: 0.1rem;
				}
			}

			.listitem:active {
				background-color: #f6f6f6;
			}
		}
	}

	// ::v-deep .van-popup{
	// 	position: absolute;
	// }

	::v-deep .van-calendar__confirm {
		height: 2.2rem;
	}

	::v-deep .van-dropdown-menu__bar {
		background-color: #0277FC;
		height: 2.2rem;
	}

	::v-deep .van-dropdown-menu__title {
		color: white;
	}

	::v-deep .van-dropdown-item__option--active {
		color: #0277FC;
	}

	::v-deep .van-dropdown-item__icon {
		color: #0277FC;
	}
</style>